import React from "react";
import { Button } from "antd";

export default function ShowGpsInfo({ closeBottomSheet }) {
  return (
    <>
      <h4 className="archive-lock-title">GPS</h4>

      <div className="m-5-0">
        در صورتی که GPS دستگاه شما روشن باشد سیستم موقعیت یابی با دقت بالاتری
        عمل می نماید
      </div>
      <div className="submit-btn m-5-0 mt-4">
        <Button type="primary" htmlType="submit" onClick={closeBottomSheet}>
          متوجه شدم
        </Button>
      </div>
    </>
  );
}
